import {
    ApiParameter,
    HasPagingParameters,
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import {
    BasePdfApiParameter,
} from "@insite/client-framework/Types/PrintPdfModels";

const vmiLocationCustomBinsUrl = "api/v1/vmiLocations/{vmiLocationId}/customBins";

export interface GetVmiBinsApiParameter extends ApiParameter, HasPagingParameters {
    vmiLocationId?: string;
    filter?: string;
    binNumberFrom?: string;
    binNumberTo?: string;
    previousCountFromDate?: string;
    previousCountToDate?: string;
    metric?: string;
    isBelowMinimum?: boolean;
    numberOfTimesMinQtyReached?: number;
    numberOfPreviousOrders?: number;
    numberOfVisits?: number;
    expand?: "product"[];
}

export interface SendVmiBinPdfApiParameter extends BasePdfApiParameter, GetVmiBinsApiParameter {
    vmiBinDetailsPageUrl: string;
}

export async function sendPdf(parameter: SendVmiBinPdfApiParameter): Promise<ServiceResult<any>> {
    try {
        const result = await post(
            `${vmiLocationCustomBinsUrl.replace("{vmiLocationId}", parameter.vmiLocationId ?? "")}/send-custom-pdf`,
            parameter,
        );
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}
